import FormattedMessage from 'I18n/components/FormattedMessage';
import { useTracker } from '../../utils/hooks/useTracker';
// @ts-expect-error untyped import
import { isEditableReport } from '../../lib/report-logic';
import { getQueryParams } from '../../lib/queryUtils';
import ActionButton from '../ActionButton';
import { EVENTS } from '../../utils/usageTracker';
// @ts-expect-error untyped import
import { useUserRoleFromScopes } from '../../utils/trackingUtils';
// @ts-expect-error untyped import
import { getDefaultReportActionEventProperties } from '../report-action-wrapper';
// @ts-expect-error untyped import
import useCreateNewReportProblem from '../shared/problemHooks/useCreateNewReportProblem';
// @ts-expect-error untyped import
import useCustomizeReportProblem from '../shared/problemHooks/useCustomizeReportProblem';
// @ts-expect-error untyped import
import openReportInBuilder from './openReportInBuilder';
import { getProblemTooltipUse } from '../problemHelpers';
// @ts-expect-error untyped import
import { getTemplateKey } from '../../data/schemas/reportSchema';
import { jsx as _jsx } from "react/jsx-runtime";
const LOAD_CONFIG_NO_TEMPLATE_KEY_OVERRIDE = true;
const EditReportTemplateButton = ({
  appUsageTracker,
  dashboardId,
  disabled: isDisabledViaParentApp = false,
  label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.editReport.button.text"
  }),
  loadConfig = false,
  onButtonClick = () => {},
  report,
  showOnDisable = true,
  tooltipMessage: appDefinedTooltip,
  tooltipPlacement,
  appDefinedBuilderLink,
  trackingProperties = {},
  openInNewTab = false,
  use,
  size,
  external,
  target
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const dashboardIdQueryParam = getQueryParams().get('dashboardId');
  const {
    createNewProblem,
    createNewDisabledMessage
  } = useCreateNewReportProblem({
    report,
    shouldBecomeCustom: true
  });
  const {
    problem: customizeProblem,
    disabledMessage: customizeDisabledMessage
  } = useCustomizeReportProblem({
    report
  });
  const problem = createNewProblem || customizeProblem;
  const disabledMessage = createNewDisabledMessage || customizeDisabledMessage;
  const isDisabled = isDisabledViaParentApp || !!problem;
  const userRole = useUserRoleFromScopes();
  const template = getTemplateKey(report);
  const defaultReportActionEventProperties = getDefaultReportActionEventProperties(report);
  const handleEditReport = e => {
    if (usageTracker) {
      usageTracker.track(EVENTS.clickCreateCustomReport, Object.assign({
        actionType: 'create',
        action: 'create-from-template',
        whichFlow: 'save-from-template',
        role: userRole,
        interactionSource: trackingProperties.interactionSource,
        templateKey: template,
        step: 'customize-template'
      }, trackingProperties, defaultReportActionEventProperties, {
        assetType: trackingProperties.assetType || defaultReportActionEventProperties.assetType
      }));
    }
    onButtonClick();
    if (!appDefinedBuilderLink) {
      openReportInBuilder({
        dashboardId: dashboardId || Number(dashboardIdQueryParam),
        loadConfig: template ? loadConfig : LOAD_CONFIG_NO_TEMPLATE_KEY_OVERRIDE,
        report,
        openInNewTab,
        whichFlow: trackingProperties.whichFlow
      });
      e.preventDefault();
    }
  };
  if (!isEditableReport(report) || isDisabled && !showOnDisable) {
    return null;
  }
  return /*#__PURE__*/_jsx(ActionButton, {
    label: label,
    disabled: isDisabled,
    tooltip: appDefinedTooltip || disabledMessage,
    tooltipUse: getProblemTooltipUse(problem),
    tooltipPlacement: tooltipPlacement,
    onClick: handleEditReport,
    href: appDefinedBuilderLink,
    use: use,
    size: size,
    external: external,
    target: target
  });
};
export default EditReportTemplateButton;